<template>
  <div class="feedback">
    <div class="title">反馈建议</div>
    <div class="content">
      <a-form
        layout="horizontal"
        class="form"
        :form="form"
        :label-col="{ xl: 2, md: 4 }"
        :wrapper-col="{ xl: 20, md: 18 }"
      >
        <a-form-item label="选择反馈建议类型" required>
          <a-radio-group v-model="formData.advise_type" @change="reasonChange" class="reasonOption">
            <a-radio v-for="(val, key) in reasonOption" :key="key" :value="key">
              {{ val }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="联系QQ">
          <a-input
            v-decorator="[
              'qq',{
                getValueFromEvent: (event) => {
                  return event.target.value.replace(/^(0+)|[^\d]+/g, '')
                },
              }
            ]"

            @change="qqChange"
            placeholder="请输入QQ号"
            :maxLength="13"

            style="width: 328px; height: 40px; border-radius: 8px"
          ></a-input>
        </a-form-item>
        <a-form-item label="具体内容">
          <div class="form-item">
            <a-textarea
              v-decorator="[
                'brief',
                {
                  rules: [
                    { required: true, message: '请填写具体内容' },
                    { max: 2000, message: '最多输入2000个字符' },
                  ],
                  initialValue: formData.content,
                },
              ]"
              placeholder="请填写具体内容"
              :max-length="2000"
              @change="briefChange"
              style="width: 80%; height: 150px; border-radius: 8px"
            />
            <span class="ant-form-text" style="color: #999999; margin-left: 16px">
              还可输入<i style="color: #ff7401">{{ 2000 - formData.content.length }}</i
              >个字符
            </span>
          </div>
        </a-form-item>
        <a-form-item>
          <span slot="label" style="font-size: 16px"> 附图</span>
          <span
            style="margin-left: 5px; font-size: 12px; color: #999999; "
          >非必填，最多上传三张，单张不超 1 M 大小，格式为PNG、JPG皆可。</span
          >

        </a-form-item>
        <a-col >
          <div class="file-box" >
            <div class="file-list" v-if="formData.elementList.length > 0">
              <div class="file-item" v-for="(item, index) in formData.elementList" :key="index">
                <div class="image-view">
                  <upload-image

                    @onSuccess="imageOnSuccess"
                    :limit="1024"
                    :data="item"
                    :path="imagePath"

                    :accept="'.jpeg,.jpg,.png'"
                    :bgImg="require('../../../assets/img/material_bg.jpg')"
                  >
                    <template slot="close">
                      <div class="close font_family icon-icon_close_spheric_24" @click.stop="deleteFile(index)"></div>
                    </template>

                  </upload-image>

                </div>
              </div>
            </div>

            <div class="cover-box" v-show="formData.elementList.length < 3">
              <multi-upload-image
                :limit="1024"
                :dataList="formData.elementList"
                :category="`1`"
                :accept="'.jpeg,.jpg,.png'"
                :path="imagePath"
                :isWaterMark="false"
                :lengthLimit="{
                  length:3,
                  errorText: '已经选择3张了，不可再上传更多啦！'
                }"
              >
              </multi-upload-image>
            </div>
          </div>
        </a-col>
        <a-col >
          <div class="submit-btn m-l-10">
            <a-button style="width:76px; height:40px;border-radius: 8px" type="primary" @click="submit">
              提交
            </a-button>
<!--            <span class="tips">-->
<!--              创作者交流群：784067577-->
<!--            </span>-->
          </div>

        </a-col>

      </a-form>
    </div>
  </div>
</template>

<script>
import MultiUploadImage from '@/components/Zpace/UploadImage/MultiUploadImage'
import UploadImage from '@/components/Zpace/UploadImage/UploadImage'
import * as qiniu from 'qiniu-js'
import { mapActions } from 'vuex'
import { getRandom } from '@/utils/util.js'
export default {
  name: 'Feedback',
  components: {
    MultiUploadImage,
    UploadImage
  },
  data () {
    return {
      form: this.$form.createForm(this),
      imagePath: 'resources/cloud/feedback/',
      reasonOption: { complaint: '功能吐槽', open: '品类开放', advise: '功能建议', question: '使用疑问', other: '其他' },
      formData: {
        contact_qq: '',
        advise_type: 'complaint',
        content: '',
        elementList: []
      },
      uploadTimer: null,
      limit: 1024
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    ...mapActions(['getQiniuToken']),
    // 生成图片名字
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    reasonChange (e) {
      this.formData.advise_type = e.target.value
    },
    briefChange (e) {
      this.formData.content = e.target.value
    },
    // 批量上传
    async onMultiUpload (file) {
      if (this.limit) {
        const isLimit = file.size / 1024 < this.limit
        if (!isLimit) {
          this.$message.error(`只能上传小于${this.limit > 1000 ? Math.floor(this.limit / 1000) + 'M' : this.limit + 'kb'}的图片`)
          return false
        }
      }
      if (this.formData.elementList.length >= 3) {
        if (this.uploadTimer) {
          clearTimeout(this.uploadTimer)
        }
        this.uploadTimer = setTimeout(() => {
          this.uploadTimer = null
          this.$message.error('已经选择3张了，不可再上传更多啦！')
        }, 500)
        return false
      }

      const typeList = '.jpeg,.jpg,.png'
      const isJpgOrPng = typeList.split(',').findIndex((item) => {
        return file.type.indexOf(item.replace(/\./g, '')) > -1
      })
      if (isJpgOrPng < 0) {
        this.$message.error(`只能上传${typeList.replace(/\./g, '').replace(/,/g, '、')}格式的图片`)
        return false
      }
      this.formData.elementList.push(
        Object.assign(
          {
            width: '',
            height: '',
            loading: false,
            percent: 0,
            title: '', // file.name.split('.')[0].substring(0, 8)
            image: '',
            watermark_image: ''
          },
          file
        )
      )
      const last = this.formData.elementList.length - 1
      await this.postImage(this.formData.elementList[last], this.imagePath)
    },
    // 上传到七牛
    async postImage (file, path) {
      const sendData = {
        action: 'upload',
        bucketType: '1'
      }
      // 获取七牛上传token
      await this.getQiniuToken(sendData)

      const params = {
        token: this.$store.state.texture.token,
        key: `${path}${this.name()}.${file.type.split('/')[1]}`
      }
      file.loading = true
      // 上传到七牛 拿到图片地址
      const observable = qiniu.upload(file.originFileObj, params.key, params.token)
      observable.subscribe({
        next: (result) => {
          // 主要用来展示进度
          file.percent = Math.round(result.total.percent).toFixed(0)
          if (file.percent === 100) {
            file.loading = false
          }
          // this.$emit('onChange', this.file)
        },
        error: () => {
          this.$message.error('上传图片失败')
        },
        complete: async (response) => {
          file.image = response.key // 返回的路径
          file.loading = false
        }
      })
    },
    // 上传图完成
    async imageOnSuccess (response, filename, file, data) {
      data.image = response.key
    },
    deleteFile (index) {
      this.formData.elementList.splice(index, 1)
    },
    qqChange (e) {
      this.formData.contact_qq = event.target.value.replace(/^(0+)|[^\d]+/g, '')
    },
    submit () {
      this.form.validateFields(async (error, values) => {
        if (error) {
          return
        }
        const { advise_type, contact_qq, content } = this.formData
        let images = []
        this.formData.elementList.forEach(item => {
          images.push(item.image)
        })
        images = images.join(',')

        this.$api.user.submit_feedback({ advise_type, contact_qq, content, images }).then(res => {
          if (res.status === 'ok') {
            this.$message.success('感谢可爱的反馈，我们会认真阅读并努力改进的！')
            this.formData = {
              contact_qq: '',
              advise_type: 'complaint',
              content: '',
              elementList: []
            }
            this.form.resetFields()
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
 .m-l-10{
  margin-left: 10px;
}
.feedback {
  .submit-btn {
    padding-top: 16px;
    margin-left: 145px;
  }
  background-color: #ffffff;
  /deep/
  .ant-radio-wrapper {
    margin-right: 30px;
  }
  /deep/
  .ant-form-item-label{
    width: 135px;
  }
  .title {
    color: #ff7401;
    font-size: 14px;
    padding: 17px 0 17px 24px;
    border-bottom: 1px solid #f2f2f2;
    line-height: 1;
  }
  .content {
    padding: 30px 36px 40px;
    font-size: 14px;
     .tips{
         display: block;
            margin-top: 24px;
            color: #999999;
            font-size: 12px;
            line-height: 1;
        }
    .form {

      .reasonOption {
        .ant-radio-wrapper {
          &.ant-radio-wrapper-checked {
            color: #333333;
          }
          color: #999999;
        }
      }
      .form-item {
        width: 100%;
        display: flex;
        align-items: center;
      }
      .file-box {
        display: flex;
        margin-left: 145px;
        margin-bottom: 24px;
        .file-list {
            display: flex;

            .file-item {
                margin-right: 20px;
                .image-view {
                     width: 120px;
                    height: 120px;
                    border-radius: 8px;
                    border: 1px solid #f2f2f2;
                    margin-bottom: 12px;
                    position: relative;
                    &:hover {
                        .close {
                            display: block;
                        }
                    }
                    .close {
                        display: none;
                        font-size: 16px;
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        color: #FFFFFF;
                        line-height: 1;
                        &:hover {
                        color: @primary-color;
                        cursor: pointer;
                        }
                    }
                }
            }
        }

        .cover-box {
          width: 120px;
          height: 120px;
          position: relative;
          overflow: hidden;

          &:hover {
            .mask {
              display: flex;
              .upload-btn {
                display: block;
              }
            }
          }
          .mask {
            display: none;
            border-radius: 4px;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);

            justify-content: center;
            align-items: center;
            pointer-events: none;
            .upload-btn {
              display: none;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
}
</style>
